import { render, staticRenderFns } from "./ModalNotificaciones.vue?vue&type=template&id=d1bd98f4"
import script from "./ModalNotificaciones.vue?vue&type=script&lang=js"
export * from "./ModalNotificaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports